<div>
    <span class="title" attr.title="{{ product.name }}">
        {{ product.name }}
        <i class="travel-icon icon-star" aria-hidden="true" *ngFor="let Star of product.category | numberToArr;"></i>
    </span>
    <small class="address">{{ product.address }}</small>
</div>